export default {

    welcome: {
        preTitle: "مرحبًا بك في",
        title: "طومبولا كوكا كولا",
        subtitle: " ! شارك الآن واحصل على فرصة للفوز.",
        message:
            "لبدء المشاركة، يُرجى رفع صورة لزجاجة كوكاكولا مفتوحة حديثًا. نتمنى لك حظًا موفقًا!",
        button: "رفع صورة",
    },
    next: "التالي",
    phone: {
        label: "أدخل رقم هاتفك",
        inputPlaceholder: "رقم هاتفك",
        description: "للمشاركة في لعبة سبين تو وين والحصول على هديتك، أدخِل رقم هاتفك.",
        error: {
            invalid: "رقم هاتف غير صالح. يرجى المحاولة مرة أخرى."
        },
        participate: "المشاركة"

    },
    error_msg: "خطأ ",

    photo: {
        label: "ارفع صورتك",
        subtitle: "أرنا زجاجة كوكاكولا التي فتحتها مؤخرًا!",
        uploadButton: "رفع الصورة",
        instructions: "تأكد من أن الصورة واضحة وقابلة للقراءة",
        successMessage: "تم استلام الصورة بنجاح!",
        remove: "حذف الصورة",

        error: {
            noPhoto: "يرجى رفع صورة للمتابعة.",
            noCaptureDate: "يجب أن تكون الصورة ملتقطة بالكاميرا. يرجى رفع صورة أخرى.",
            photoOld: "يرجى رفع صورة حديثة.",
            invalid: "صورة غير صالحة.",
            photo_too_big: "حجم الصورة أكبر من المسموح.",
            compressionFailed: "فشل في ضغط الصورة.",
            invalid_link: "الرابط خاطئ أو منتهي الصلاحية.",


            missing_photo: "يرجى رفع صورة.",
            invalid_photo_format: "صيغة الصورة غير صالحة. استخدم JPG أو PNG.",
            photo_failed_to_upload: "فشل رفع الصورة.",
            invalid_photo_content: "صورة القارورة غير صالحة. يرجى التقاط صورة واضحة لقارورة من علامة كوكاكولا وهي مفتوحة.",
            invalid_brand: "صورة القارورة غير صالحة. يرجى التقاط صورة واضحة لقارورة من علامة كوكاكولا وهي مفتوحة.",
            not_a_bottle: "صورة القارورة غير صالحة. يرجى التقاط صورة واضحة لقارورة من علامة كوكاكولا وهي مفتوحة.",
            cap_not_removed: "صورة القارورة غير صالحة. يرجى التقاط صورة واضحة لقارورة من علامة كوكاكولا وهي مفتوحة.",
            low_confidence_detection: "صورة القارورة غير صالحة. يرجى التقاط صورة واضحة لقارورة من علامة كوكاكولا وهي مفتوحة.",
            verification_failed: "فشل معالجة الصورة يرجى إعادة إلتقاط صورة واضحة القارورة من علامة كوكاكولا وهي مفتوحة.",

        }
    },
    scanBottle: {
        loading: "جارٍ فحص صورتك..."
    },
    camera: {
        title: "كاميرا كوكاكولا",
        description: "قم بالتقاط صورة واضحة لزجاجة الكوكاكولا الخاصة بك وهي مفتوحة.",
        permission_message: "يرجى السماح بالوصول إلى الكاميرا للمتابعة.",
        open_button: "فتح الكاميرا",
        capture: "التقاط الصورة",
        preview: "المعاينة",
        save: "حفظ",
        retry: "إعادة المحاولة"
    },
    spin: {
        label: "دوّر العجلة",
        subtitle: "جرب حظك للفوز بنقاط ",
        spinButton: "دوّر",
        winMessage: "تهانينا! لقد ربحت:",
        loseMessage: "محاولة غير ناجحة، جرّب مرة أخرى!",
        instructions: "اضغط على الزر لتجربة حظك"
    },
    celebration: {
        title: "تهانينا!",
        subtitle: "لقد فزت",
        shareMessage: "شارك فوزك مع أصدقائك",

        physical_message: "سنتواصل معك لتسليم جائزتك.",
        digital_message: "قم بتنزيل التطبيق Gifty لاستلام جائزتك.",
        download_app_button: "تحميل التطبيق",
    }
};